<template>
  <div>
    <b-loading :active="loading" />
    <div class="mx-10 my-11 pb-8 sm:mx-1">
      <div class="flex flex-col mb-6">
        <w-button
          class="wrapper__go-back"
          type="text"
          @click="goBack"
        >
          <i class="icon icon-chevron-left-bold text-gray-500" />
          返回例行性訂購列表
        </w-button>
      </div>
      <template v-if="!loading">
        <schedule-setting
          :groupBuyingSetting="groupBuyingSetting"
          :groupBuyings="groupBuyings"
          :scheduleSetting="scheduleSetting"
          />
      </template>
    </div>
  </div>
</template>

<script>
import EditSchedule from './EditSchedule';

export default EditSchedule;
</script>

<style lang="scss" scoped>
@import './EditSchedule.scss';
</style>
